import { Badge } from "./catalyst/badge";

export const BadgeByRole = ({
  role,
  displayRole,
}: {
  role: string;
  displayRole: string;
}) => {
  const badgeColor = (role: string) => {
    switch (role) {
      case "player":
        return "yellow";
      case "teamOwner":
      case "nonPlayingTeamOwner":
        return "blue";
      case "playingTeamOwner":
        return "green";
      case "admin":
        return "red";
      default:
        return "gray";
    }
  };

  return <Badge color={badgeColor(role) as any}>{displayRole}</Badge>;
};
